






























































































import Vue from 'vue'
import Component from 'vue-class-component'
import ProfileMenu from './ProfileMenu.vue'
import { profileColor, profileAbb } from '@/api/graphicIdentifier';

@Component({
    components: {
        ProfileMenu
    }
})
export default class TheToolbarMobile extends Vue {
    menu = false
    basket = false
    siteStatus = false
    profileColor = profileColor
    profileAbb = profileAbb
}
